import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IVariables } from './list'
import { ExportFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

const mutation = gql`
  mutation CreateEmployeeExport($input: CreateEmployeeExportInput!) {
    createEmployeeExport(input: $input) {
      export {
        ...ExportFragment
      }
    }
  }
  ${ExportFragment}
`

interface Export {
  id?: string
  url?: string
}

interface IPayload {
  createEmployeeExport: {
    export: Export
  }
}

const mutateHandler = handleFetchResult<IPayload, Export>({
  handler: (data) => data.createEmployeeExport.export,
  name: 'Export',
})

export default function createExport(input: IVariables): Promise<Export> {
  return client.gql
    .mutate({
      mutation,
      variables: {
        input,
      },
    })
    .then(mutateHandler)
}
